import authorityMasterDetailPage from './authorityMasterDetailPage';

export default authorityMasterDetailPage;